<template>
    <div class="container is-fullwidth mt-2 content">
        <h2 class="title">Personal Details</h2>
        <div class="columns">
            <div class="column is-3 has-text-weight-bold">
                Applicant Name
            </div>
            <div class="column is-3">
                {{ application.title}} {{ application.forename}} {{ application.surname}}
            </div>
            
            <div class="column is-3 has-text-weight-bold">
                Governing Body
            </div>
            <div class="column is-3">
                {{ application.governing_body_name}}
            </div>
        </div>
        <div class="columns">
            <div class="column is-3 has-text-weight-bold">
                Date of Birth
            </div>
            <div class="column is-3">
                {{ application.dob}}
            </div>
       
            <div class="column is-3 has-text-weight-bold">
                Email
            </div>
            <div class="column is-3">
                {{ application.email}}
            </div>
        </div>
        <div class="columns" v-if="application.parent_name != '' && application.parent_relationship != ''">
            <div class="column is-3 has-text-weight-bold">
               Parent/Guardian Name
            </div>
            <div class="column is-3">
                {{ application.parent_name}}
            </div>
       
            <div class="column is-3 has-text-weight-bold">
                Relationship
            </div>
            <div class="column is-3">
                {{ application.parent_relationship}}
            </div>
        </div>
        <div class="columns" v-if="application.parent_email != '' && application.parent_telephone != ''">
            <div class="column is-3 has-text-weight-bold">
               Parent/Guardian Email
            </div>
            <div class="column is-3">
                {{ application.parent_email}}
            </div>
       
            <div class="column is-3 has-text-weight-bold">
                 Parent/Guardian Telephone
            </div>
            <div class="column is-3">
                {{ application.parent_telephone}}
            </div>
        </div>
         <div class="columns" >
            <div class="column is-3 has-text-weight-bold">
               Telephone (Home)
            </div>
            <div class="column is-3">
                {{ application.telephone}}
            </div>
       
            <div class="column is-3 has-text-weight-bold">
                 Telephone (Mobile)
            </div>
            <div class="column is-3">
                {{ application.mobile}}
            </div>
        </div>
        <div class="columns" >
            <div class="column is-3 has-text-weight-bold">
               Where you live 
            </div>
            <div class="column is-3">
                {{ application.council_area}}
            </div>
       
            <div class="column is-3 has-text-weight-bold">
                Address
            </div>
            <div class="column is-3">
                {{ application.address}}
            </div>
        </div>
         <div class="columns" >
            <div class="column is-3 has-text-weight-bold">
               City
            </div>
            <div class="column is-3">
                {{ application.city}}
            </div>
       
            <div class="column is-3 has-text-weight-bold">
                State/Region
            </div>
            <div class="column is-3">
                {{ application.state}}
            </div>
        </div>
        <div class="columns" >
            <div class="column is-3 has-text-weight-bold">
               Postcode
            </div>
            <div class="column is-3">
                {{ application.postcode}}
            </div>
       
            <div class="column is-3 has-text-weight-bold">
                Country
            </div>
            <div class="column is-3">
                {{ application.country}}
            </div>
        </div>
        <div class="columns" >
            <div class="column is-3 has-text-weight-bold">
              Name of School
            </div>
            <div class="column is-3">
                {{ application.school_name}}
            </div>
       
            <div class="column is-3 has-text-weight-bold">
                Social Media
            </div>
            <div class="column is-3">
                {{ application.social_handle}}
            </div>
        </div>
        <div class="columns" >
            <div class="column is-3 has-text-weight-bold">
              Employment
            </div>
            <div class="column is-3">
                {{ application.employment}}
            </div>
       
            <div class="column is-3 has-text-weight-bold">
                Education
            </div>
            <div class="column is-3">
                {{ application.education}}
            </div>
        </div>

        <h2 class="title mt-4">Funding Requirements</h2>
        <div class="mb-4">
            <div class="has-text-weight-bold">
                Targetted Event / Date / Venue / Cost
            </div>
            <div class="">
                {{ application.target_event}} / {{ application.target_event_date}} / {{ application.target_event_venue}} / {{ application.target_event_cost}}
            </div>
        </div>
        <div class="mb-4">
            <div class="has-text-weight-bold">
                Training & Competitive Programme in preparation for Targeted Event
            </div>
            <div class="">
                <table class="table is-fullwidth" v-if="application.training.length > 0">
                    <thead>
                        <tr>
                            <th>Details</th>
                            <th>Cost (£)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, index) in application.training" :key="index">
                            <td>{{ row.details }}</td>
                            <td>{{ row.cost }}</td>
                        </tr>
                    </tbody>
                </table>
                <div v-if="application.training.length === 0">No training details entered</div>
            </div>
        </div>

        
         <div class="mb-4">
            <div class="has-text-weight-bold">
                Details of other financial support revieved in past 12 months
            </div>
            <div class="">
                <table class="table is-fullwidth" v-if=" application.support.length > 0">
                    <thead>
                        <tr>
                            <th>Finance Body</th>
                            <th>Amount (£)</th>
                            <th>Date Received</th>
                            <th>Other Comments</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, index) in application.support" :key="index">
                            <td>{{ row.finance_body }}</td>
                            <td>{{ row.amount }}</td>
                            <td>{{ row.date }}</td>
                            <td>{{ row.comments }}</td>
                        </tr>
                    </tbody>
                </table>
                <div v-if=" application.support.length === 0">No previous support details entered</div>
            </div>
        </div>

        <div class="mb-4">
            <div class="has-text-weight-bold">
                Governing Body Report and Recommendations (to be completed by Governing Body only)
            </div>
            <div class="">
                <table class="table is-fullwidth" v-if="application.ranking.length > 0">
                    <thead>
                        <tr>
                            <th>Ranking Area</th>
                            <th>Rank</th>
                            
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, index) in application.ranking" :key="index">
                            <td>{{ row.area }}</td>
                            <td>{{ row.rank }}</td>
                           
                        </tr>
                    </tbody>
                </table>
                <div v-if="application.ranking.length === 0">No previous ranking details entered</div>
            </div>
        </div>
        <div class="mb-4">
            <div class="has-text-weight-bold">
               Major Achievements (in the past 2 years, in chronological order)
            </div>
            <div class="textbox" v-html="application.achievements.replace(/\n/g, '<br />')">
               
            </div>
        </div>
         <div class="mb-4">
            <div class="has-text-weight-bold">
               Potential
            </div>
            <div class="textbox" v-html="application.potential.replace(/\n/g, '<br />')">
               
            </div>
        </div>
         <div class="mb-4">
            <div class="has-text-weight-bold">
               Other Relevant Comments
            </div>
            <div class="textbox" v-html="application.other_comments.replace(/\n/g, '<br />')">
              
            </div>
        </div>

        <div class="mb-4">
            <div class="has-text-weight-bold">
               Assessment of financial need
            </div>
            <div class="">
                <table class="table is-fullwidth" v-if="application.needs.length > 0">
                    <thead>
                        <tr>
                            <th>Priority</th>
                            <th>Comments</th>
                            
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, index) in application.needs" :key="index">
                            <td>{{ row.priority }}</td>
                            <td>{{ row.comments }}</td>
                           
                        </tr>
                    </tbody>
                </table>
                <div v-if="application.needs.length === 0">No previous needs details entered</div>
            </div>
        </div>
        
    </div>

</template>

<script>
import ApplicationService from '@/services/ApplicationService.js';

export default {
    data() {
        return {
            application: {training: [],  support: [], ranking: [], needs: []},
        }
    },
    created() {
    
    this.getApplicationData();
    
   
  },
  methods : {
      async getApplicationData() {
      const accessToken = await this.$auth.getTokenSilently()
      // Use the eventService to call the getEventSingle() method
      ApplicationService.getApplication(accessToken, this.$route.params.id)
      .then(
        (application => {
          this.$set(this, "application", application);
        }).bind(this)
      )
      .catch((error) => {
       this.notfound = 1
        console.log(error)
      });

    }
    
  }
}
</script>

<style scoped>
    .columns {margin-bottom:0px;}
    table td, table th {padding:5px 0px}
    .table th {white-space: nowrap;}
    
    @media print {
        .content {font-size:0.8em !important}
    }

</style>